import { bandittoApi } from '../../store/api/api';
import routes from '../../routes';
import { ReferralRewardsInfo, ReferralRewardsRequest } from './referralRewards.types';

type SuccessResponse = {
  success: boolean;
};

const referralRewardsApi = bandittoApi.injectEndpoints({
  endpoints: (builder) => ({
    getReferralRewards: builder.query<ReferralRewardsInfo, ReferralRewardsRequest>({
      query: (params) => ({
        url: routes.api.referralRewards(),
        params,
      }),
      providesTags: ['ReferralRewards'],
    }),
    approveReferralReward: builder.mutation<SuccessResponse, string>({
      query: (inviteeId) => ({
        url: routes.api.approveReferralReward(inviteeId),
        method: 'POST',
      }),
      invalidatesTags: ['ReferralRewards'],
    }),
    rejectReferralReward: builder.mutation<SuccessResponse, { inviteeId: string; reason: string }>({
      query: ({ inviteeId, reason }) => ({
        url: routes.api.rejectReferralReward(inviteeId),
        method: 'POST',
        body: { reason },
      }),
      invalidatesTags: ['ReferralRewards'],
    }),
  }),
});

export const {
  useGetReferralRewardsQuery,
  useApproveReferralRewardMutation,
  useRejectReferralRewardMutation,
} = referralRewardsApi;
